export const videoTitle = (filename) => {
  if (typeof filename !== "string") return "";
  return filename.replace(/[-_]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
export const docTitle = (filename) => {
  if (typeof filename !== "string") return "";
  return filename.replace(/[-_]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
export const utilsTitle = (filename) => {
  if (typeof filename !== "string") return "";
  return filename.replace(/[-_]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}